export default "__VITE_ASSET__D4qDwM0s__"